import React from 'react'
import * as Sentry from '@sentry/react'
import { env, sentry } from '../../config'

const IssuesTrackersService = {
  captureError: (error, hint) => {
    const errorToCapture = error instanceof Error ? error : new Error(error)
    Sentry.captureException(errorToCapture, hint)
    /* eslint-disable no-console */
    if (typeof console.groupCollapsed === 'function') {
      console.groupCollapsed(`${error.message} error and hint`)
    }
    console.error('error', error)
    if (typeof console.info === 'function') {
      console.info('hint', hint)
    }
    if (typeof console.groupEnd === 'function') {
      console.groupEnd()
    }
    /* eslint-enable no-console */
  },

  initialize: async () => {
    Sentry.init({
      dsn: sentry.url,
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
        }),
        Sentry.replayIntegration(),
      ],
      environment: process.env.NODE_ENV === 'development' ? 'development' : env,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      tracesSampleRate: sentry.tracesSampleRate,
      replaysSessionSampleRate: sentry.replaysSessionSampleRate,
      replaysOnErrorSampleRate: 1.0,
      normalizeDepth: 10,
      ignoreErrors: ['Network Error', 'Failed to fetch', 'Load failed'],
    })

    if (typeof process.env.REACT_APP_GIT_SHA1 !== 'string') {
      return
    }

    Sentry.setContext('application', {
      gitCommitHash: process.env.REACT_APP_GIT_SHA1,
    })
  },

  log: message => {
    Sentry.captureMessage(message)
  },

  setUserContext: async ({ proId, proUserId }) => {
    Sentry.setUser({
      id: proUserId,
      username: `proUserId:${proUserId},proId:${proId}`,
    })
    Sentry.setContext('user', {
      proId,
      proUserId,
    })
  },
}

export default IssuesTrackersService
